import React from "react";

const FTFRBusinesses = ({ title, businesses }) => {
  return (
    <section className="ftfr-businesses-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
        </div>

        <div className="row g-4">
          {businesses.map((business, i) => (
            <div
              key={i}
              className="col-md-6"
              data-aos="fade-up"
              data-aos-delay={`${i * 100}`}
              data-aos-once="true"
            >
              <div className="ftfr-business-card">
                <p className="ftfr-business-title">{business.title}</p>
                <p className="ftfr-business-desc">{business.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FTFRBusinesses;
